export default [
    /**
     * 独立视频房间页，仅需房间id
     * @query.id
     */
    {
        path: '/other/single/chat',
        meta: {title: '会诊间'},
        component: () => import('../views/other/single/chat')
    },
    /**
     * 直播控制台
     * @query.room
     */
    {
        path: '/other/live/console',
        meta: {title: '直播控制台', needLogin: false},
        component: () => import('../views/other/live/console')
    },
    /**
     * 远程门诊全屏
     * @query.room
     */
    {
        path: '/other/ycmz/fullscreen',
        meta: {title: '远程门诊'},
        component: () => import('../views/other/ycmz/fullscreen')
    },
    /**
     * 远程会诊全屏
     * @query.room
     */
    {
        path: '/other/ychz/fullscreen',
        meta: {title: '远程会诊', needLogin: false},
        component: () => import('../views/other/ychz/fullscreen-tencent')
        // component: () => import('../views/other/ychz/fullscreen')
    },
    /**
     * 打印处方随货单
     * @query.room
     */
    {
        path: '/other/print/recipe/shd',
        meta: {title: '打印处方随货单', needLogin: false},
        component: () => import('../views/other/print/recipe/shd')
        // component: () => import('../views/other/ychz/fullscreen')
    }
]
